<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row justify-content-center">
              <!-- <div class="col-lg-6 d-none d-lg-block"></div> -->
              <div class="col-lg-6 col-md-9 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Selbeg.MN admin системд нэвтэрнэ үү!</h1>
                  </div>
                  <div class="user" autocomplete="off">
                    <button @click="googleSignIn" type="button" class="btn btn-google btn-block" v-if="loading==false">
                      <i class="fab fa-google fa-fw"></i> Login with Google
                    </button>
                    <button type="button" v-else class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "Adminman",
  data() {
    return {
      loginForm: {
        register: "",
        code: ""
      },
      user: {
        email: null,
        phone: null
      },
      showUserName: true,
      showCode: false,
      showAddInfo: false,
      isTeacher: false,
      loading:false
    };
  },
  methods: {
    async googleSignIn() {
      this.loading=true;
      fb.googleProvider.addScope("profile");
      fb.googleProvider.addScope("email");
      fb.auth
        .signInWithPopup(fb.googleProvider)
        .then(result => {
          var token = result.credential.accessToken;
          var user = result.user;
          // console.log(user);
          // console.log(user.email);
          // console.log(result);
          // // if (result.additionalUserInfo.isNewUser) {
          //   console.log("it is new user");
          //   console.log(result.additionalUserInfo.profile.email);

            fb.db.collection("admins")
                    .where("email", "==", result.additionalUserInfo.profile.email)
                    .limit(1)
                    .get().then(stsdata=>{
                      // console.log(stsdata);
                      if (!stsdata.empty) {
                        var userObj = stsdata.docs[0];
                        console.log('user found');
                        if(userObj!=null && userObj.data().role!=null && userObj.data().role!=''){
                          fb.usersCollection
                          .doc(user.uid)
                          .get()
                          .then(userData => {
                            if (userData.exists) {
                              userData.ref.update({ provider: "google", role:userObj.data().role, name: user.displayName,
                                  email:result.additionalUserInfo.profile.email,customer: stsdata.docs[0].ref,
                                  verified:true});
                                console.log(userData.data());
                                this.$store.dispatch("setEnabledTrue");
                                this.$store.dispatch("fetchUserProfile");
                                this.performingRequest = false;

                                this.$store.commit("setCurrentUser", user);
                                this.$router.push("/hello");
                                
                            }
                            else {
                              fb.usersCollection
                                .doc(user.uid)
                                .set({
                                  name: user.displayName,
                                  email:result.additionalUserInfo.profile.email,
                                  provider: "google",
                                  role:userObj.data().role,
                                  customer: stsdata.docs[0].ref,
                                  verified:true
                                })
                                .then(() => {
                                  this.$store.dispatch("setEnabledTrue");
                                  this.$store.dispatch("fetchUserProfile");
                                  this.performingRequest = false;
                                  this.$store.commit("setCurrentUser", user);
                                  this.$router.push("/hello");
                                })
                                .catch(err => {
                                  console.log(err);
                                  this.performingRequest = false;
                                  this.errorMsg = err.message;
                                });
                            }
                            this.loading=false;
                          });
                        }
                      }
                      else{
                        this.loading=false;
                        console.log('USER IS NOT FOUND!!!');
                        this.$store.dispatch("setEnabledFalse");
                        this.$store.dispatch("fetchUserProfile");
                        this.performingRequest = false;
                        this.$store.commit("setCurrentUser", user);
                        this.$router.push("/addinfo");
                        alert("Та системд бүртгэлгүй байна.");
                      }
                      
                    });
          
          // }
        })
        .catch(function(error) {
          this.loading=false;
          console.log(error);
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          this.$store.dispatch("setEnabledFalse");
          // ...
        });
    }
  }
};
</script>

